export default function DocumentsSection() {
  const documentCategories = [
    {
      title: '必ず必要なもの',
      icon: 'ri-file-list-3-line',
      color: 'from-red-500 to-pink-500',
      items: [
        '会社実印（会社代表印）',
        '売主様個人の印鑑証明書',
        '売主様個人のご身分証写し'
      ]
    },
    {
      title: '状況に応じて必要となるもの',
      icon: 'ri-file-text-line',
      color: 'from-teal-500 to-cyan-500',
      items: [
        '法人の印鑑証明書',
        '法人の納税証明書その3の3'
      ],
      links: [
        { text: '書類の集め方（法務局編）', url: '#' },
        { text: '書類の集め方（税務署編）', url: '#' }
      ]
    },
    {
      title: '会社譲渡時にあったほうがいいもの',
      icon: 'ri-folder-line',
      color: 'from-cyan-500 to-blue-500',
      items: [
        '決算書',
        '法人名義のお口座',
        '法人設立時の書類（定款、青色申告の届出、法人番号通知書、社会保険関連の書類など）'
      ],
      note: '会社の書類や物品は沢山あるにこしたことはございません。上記のような書類などがあるのであれば、おまとめ頂けると助かります。'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-file-list-line text-teal-600 text-xl mr-3"></i>
            <span className="text-sm font-bold text-teal-600">DOCUMENTS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            必要<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">書類・物品</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            スムーズな売却手続きのために、以下の書類をご準備ください
          </p>
        </div>

        {/* Documents Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {documentCategories.map((category, index) => (
            <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${category.color} rounded-2xl flex items-center justify-center mb-6 shadow-lg`}>
                <i className={`${category.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-black text-gray-900 mb-6">{category.title}</h3>

              {/* Items */}
              <ul className="space-y-3 mb-6">
                {category.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className={`w-6 h-6 bg-gradient-to-br ${category.color} rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5`}>
                      <i className="ri-check-line text-sm text-white"></i>
                    </div>
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              {/* Links */}
              {category.links && (
                <div className="space-y-2 mb-6">
                  {category.links.map((link, idx) => (
                    <a key={idx} href={link.url} className="flex items-center gap-2 text-sm text-teal-600 hover:text-teal-700 font-bold group cursor-pointer">
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                      {link.text}
                    </a>
                  ))}
                </div>
              )}

              {/* Note */}
              {category.note && (
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                  <p className="text-xs text-gray-600 leading-relaxed">{category.note}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
